import React from 'react';
import { Search as SearchIcon } from 'lucide-react';

const Search = () => {
  return (
    <div className="tw-relative tw-hidden lg:tw-block">
      <div className="tw-absolute tw-inset-y-0 tw-left-0 tw-pl-3 tw-flex tw-items-center tw-pointer-events-none">
        <SearchIcon className="tw-h-4 tw-w-4 tw-text-gray-400" />
      </div>
      <input
        type="text"
        className="tw-block tw-w-64 tw-pl-10 tw-pr-3 tw-py-2 tw-border-none tw-bg-gray-100/80 hover:tw-bg-gray-100 tw-rounded-2xl tw-text-sm tw-placeholder-gray-400 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-blue-500/20 tw-transition-all"
        placeholder="Search..."
      />
    </div>
  );
};

export default Search;
